import PropTypes from "prop-types";

/** One form section as the FormShell components see it (HLD §7). */
export const SectionStatusShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  requiredTotal: PropTypes.number.isRequired,
  filledRequired: PropTypes.number.isRequired,
  errorCount: PropTypes.number.isRequired,
  locked: PropTypes.bool,
});

/** One pill in FormErrorSummary (HLD §7). No fieldId -> plain, unclickable pill. */
export const ErrorItemShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  message: PropTypes.string,
  fieldId: PropTypes.string,
  sectionId: PropTypes.string,
});
